import { render } from "./SocialstyrelsenGenericDrugsView.vue?vue&type=template&id=25814504"
import script from "./SocialstyrelsenGenericDrugsView.vue?vue&type=script&lang=js"
export * from "./SocialstyrelsenGenericDrugsView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__